import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, NAV, waLink } from "../lib/config";
import { ContactForm } from "./ContactForm";

export const Footer = () => {
  const { pathname } = useLocation();
  const showForm = pathname === "/" || pathname === "/contacto";
  return (
  <footer data-testid="site-footer" className="bg-ink text-bg-primary">
    <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
      <div className="grid gap-16 lg:grid-cols-2">
        <div>
          <p className="overline text-sand">Escríbeme</p>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight md:text-5xl">
            Hablemos
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-bg-primary/70">
            Cuéntame qué necesitas y valoraremos juntos cómo puedo ayudarte. Atención con cita previa,
            presencial en Málaga o en modalidad online.
          </p>

          <div className="mt-10 space-y-4 text-sm">
            <a href={`tel:+34${SITE.phone}`} data-testid="footer-phone" className="flex items-center gap-3 text-bg-primary/80 transition-colors hover:text-white">
              <Phone className="h-5 w-5 text-sand" strokeWidth={1.5} /> {SITE.phoneDisplay}
            </a>
            <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 text-bg-primary/80 transition-colors hover:text-white">
              <Mail className="h-5 w-5 text-sand" strokeWidth={1.5} /> {SITE.email}
            </a>
            <p className="flex items-center gap-3 text-bg-primary/80">
              <MapPin className="h-5 w-5 text-sand" strokeWidth={1.5} /> {SITE.address}, {SITE.city}
            </p>
            <p className="flex items-center gap-3 text-bg-primary/80">
              <Clock className="h-5 w-5 text-sand" strokeWidth={1.5} /> {SITE.schedule}
            </p>
          </div>
        </div>

        {showForm && (
          <div className="rounded-4xl bg-bg-primary/5 p-6 md:p-8 [&_input]:!bg-white/5 [&_input]:!border-white/15 [&_input]:!text-white [&_input]:placeholder:!text-white/40 [&_textarea]:!bg-white/5 [&_textarea]:!border-white/15 [&_textarea]:!text-white [&_textarea]:placeholder:!text-white/40 [&_a]:!text-sand [&_span]:!text-white/70 [&_button[type=submit]]:!bg-sand [&_button[type=submit]]:!text-ink">
            <p className="mb-6 font-serif text-2xl">Formulario rápido</p>
            <ContactForm compact testId="footer-contact-form" subject="Contacto rápido (footer)" />
          </div>
        )}
      </div>

      <div className="mt-20 flex flex-col gap-8 border-t border-white/10 pt-10 md:flex-row md:items-center md:justify-between">
        <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-bg-primary/70">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="transition-colors hover:text-white">{n.label}</Link>
          ))}
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">WhatsApp</a>
        </nav>
        <nav className="flex flex-wrap gap-x-6 gap-y-3 text-xs text-bg-primary/50">
          <Link to="/aviso-legal" data-testid="footer-aviso-legal" className="transition-colors hover:text-white">Aviso legal</Link>
          <Link to="/politica-privacidad" data-testid="footer-privacidad" className="transition-colors hover:text-white">Política de privacidad</Link>
          <Link to="/politica-cookies" data-testid="footer-cookies" className="transition-colors hover:text-white">Política de cookies</Link>
        </nav>
      </div>
      <p className="mt-8 text-xs text-bg-primary/40">
        © {new Date().getFullYear()} {SITE.name} · {SITE.role} · Colegiada nº {SITE.colegiada} · {SITE.colegio}
      </p>
    </div>
  </footer>
  );
};
